import { useRequiredParam } from '@/hooks/useRequiredParam';

/**
 * Gets the document ID from the URL route parameter.
 * Simple wrapper around useRequiredParam for consistency with other hooks.
 */
export function useDocumentId() {
  const documentId = useRequiredParam('documentId');

  return {
    documentId,
  };
}
